import AuthLayout from "@container/layout/auth";
import AgentCallDetail from "@container/agent-calls/detail";

export default function AgentCallDetailPage() {
    return (
        <AuthLayout>
            <AgentCallDetail />
        </AuthLayout>
    );
}
